export default Object.freeze({
    debug: true,
    title: "タスク一覧",
    actl:   "greenc-child-tasks",
    aaction: "list",
    detail_aaction: "view",
    detail_response: "greencChildTask",
    detail: "greenc-child-tasks",
    list: "list", // ここだけ今の所固定
    saveAdd: "add",
    saveEdit: "edit",
    saveDelete: "softdelete",
    linkEdit: "greenc-child-tasks-edit",
    target_key: null
});